// extracted by mini-css-extract-plugin
export default {"emptyBlock":"empty_emptyBlock__6VTAV","description":"empty_description__GJOF9","button":"empty_button__Ma5xg"};